"use strict";
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
const errors = __importStar(require("../errors"));
const fs = __importStar(require("fs"));
const JSON5 = __importStar(require("json5"));
class Json5Processor {
    async execute(ctx) {
        let virtualPath = ctx.virtualPath;
        if (!virtualPath.endsWith(".json") && !virtualPath.endsWith(".json5"))
            return null;
        let physicalPath = ctx.rootDirectory.findFile(virtualPath);
        if (physicalPath == null)
            throw errors.pageNotFound(virtualPath);
        let buffer = fs.readFileSync(physicalPath);
        let obj = JSON5.parse(buffer.toString());
        const encoding = 'UTF-8';
        return {
            content: JSON.stringify(obj),
            headers: { "content-type": `application/json; charset=${encoding}` }
        };
    }
}
exports.Json5Processor = Json5Processor;
